import { ReaderAuthDialog } from '../components/ReaderAuthDialog';

export default function SignupPage() {
  return <ReaderAuthDialog signup />;
}
